<div class="card__client">
    <div class="client__button-wrapper">
        <button
            class="button button_with-icon button_theme_main client__button"
            (click)="openDialog()"
            [disabled]="isDisabled(20) || !(custcard_3 && custcard_3.pelephone)"
        >
            שלח סמס
            <img class="button__icon" src="/assets/img/chat-dots.svg" alt="chat-dots" />
        </button>

        <a
            class="button button_with-icon button_theme_main client__button"
            href="{{ getWhatsAppLink() }}"
            target="_blank"
            [ngClass]="{ client__button_disabled: isDisabled(20) || !(custcard_3 && custcard_3.pelephone) }"
        >
            שלח וואטסאפ
            <img class="button__icon" src="/assets/img/whatsapp.svg" alt="icon-whatsapp" />
        </a>
    </div>

    <div class="client__info">
        <div class="info__header">
            <button class="button button_icon-only header__button button-back" (click)="backToClients()">
                <i class="fa-regular fa-arrow-left"></i>
            </button>

            <div class="header__main">
                <div class="main__text">
                    <div *ngIf="custcard_1.age > 0 || custcard_1.sex" [ngSwitch]="custcard_1.sex" class="main__name">
                        <span class="main__name_bold">{{ custcard_1.fl }}</span>
                        <span class="main__details">
                            (<span *ngSwitchCase="1">לא מוגדר</span>
                            <span *ngSwitchCase="2">אישה</span>
                            <span *ngSwitchCase="3">גבר</span>
                            <span *ngIf="custcard_1.age > 0">, {{ custcard_1.age }}</span
                            >)
                        </span>
                    </div>
                    <span class="main__description">{{ custCardTabService.tabTitle }}</span>
                </div>

                <img
                    *ngIf="custcard_3 && custcard_3.imagePath && config"
                    class="main__image"
                    [src]="getClientImageSrc(custcard_3)"
                    (error)="clearImagePath(custcard_3.customerId)"
                    alt="Client image"
                />
                <img *ngIf="!custcard_3.imagePath" class="main__image" src="/assets/img/client-avatar.png" alt="Client image" />
            </div>

            <app-sidebar></app-sidebar>
        </div>

        <div class="info__tags-wrapper">
            <div *ngFor="let tag of customClassificationData" class="info__tag" [ngClass]="{ 'birthday-tag': tag.id == 1, 'debt-tag': tag.id == 2 }">
                <span *ngIf="tag.id == 1" class="tag__name">{{ tag.name }}</span>
                <i *ngIf="tag.id == 1" class="fa-solid fa-cake-candles"></i>

                <span *ngIf="tag.id == 2" class="tag__name">{{ tag.name }}</span>
                <i *ngIf="tag.id == 2" class="fa-duotone fa-coins"></i>

                <span *ngIf="tag.id == 3" class="tag__name">{{ tag.name }}</span>
            </div>
        </div>
    </div>
</div>
